import React, { useEffect, useState } from 'react';

import callApi from '../../utils/callApi';
import { ANCHOR_VIEW } from '../../constants/apiUrls/apiUrls';
import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';

import styles from './css/MeetOurAnchorsSection.module.css';
import SubscribeCTAButton from './SubscribeCTAButton';


const NAKED_NEWS_LIVE_ID = 241;


function MeetOurAnchorsSection(props) {
  const [videoData, setVideoData] = useState({
    videoUrl: null,
    imageUrl: null,
  });
  const {
    sectionContent: {
      heading1,
      heading2,
      content,
      image,
      url,
      logo,
      target,
    },
    title,
    user,
    isNNLSection,
  } = props;

  useEffect(() => {
    if (isNNLSection) {
      const NNL_URL = ANCHOR_VIEW.replace('{id}', NAKED_NEWS_LIVE_ID);
      callApi(NNL_URL, 'get').then((res) => {
        setVideoData({
          videoUrl: res.data.promoClip,
          imageUrl: image,
        });
      }).catch(() => {
        setVideoData({
          videoUrl: '',
          imageUrl: image,
        });
      });
    }
  }, [isNNLSection, image]);

  if (isNNLSection && logo) {
    return (
      <main className={styles.guestHomeMain}>
        <div className={styles.guestSectionLeft}>
          <img alt="NakedNewsLive" className={styles.carouselLogo} src={logo} />
          <div className={styles.description}>
            <p className={styles.description}>{content}</p>
          </div>
          <SubscribeCTAButton alignRight={true} title={title} />
        </div>
        <div className={styles.guestVideoRight} id="guest-video-right">
          <SimpleVideoPlayer
            key="video_2"
            clip={videoData}
            fanZoneFreeVideo={true}
            isNNLSection={isNNLSection}
            user={user}
          />
        </div>
      </main>
    );
  }

  return (
    <main className={styles.guestHomeMain}>
      <div className={styles.guestSectionLeft}>
        <div>
          <h2 className={styles.headerText}>{heading1}</h2>
          <h1 className={styles.headerText}>{heading2}</h1>
        </div>
        <div className={styles.description}>
          <p>{content}</p>
        </div>
        <SubscribeCTAButton alignRight={true} title={title} />
      </div>
      <a className={styles.anchorImageGuest} href={url} target={target}>
        <img alt="meet-our-anchors" className={styles.anchorImage} src={image} />
      </a>
    </main>
  );
}

export default MeetOurAnchorsSection;
